import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('phone_alt') as string || '').trim();

    if (honeypotValue) {
      setStatus('success');
      setMessage('感謝您的訂閱！');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9suvul8o1vn02ekumf0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感謝您的訂閱！我們將定期為您送上三上悠亞的最新消息。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        setStatus('error');
        setMessage(serverMsg || '訂閱失敗，請稍後再試。');
      }
    } catch {
      setStatus('error');
      setMessage('網絡異常，請稍後再試。');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16">
      <div className="max-w-2xl mx-auto text-center">
        <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3">
          訂閱電子報
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
          第一時間獲取最新資訊
        </h2>
        <p className="text-sm text-foreground-600 mb-7 max-w-md mx-auto">
          訂閱三上悠亞官方電子報，不錯過任何最新作品、活動與獨家內容。
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-2 p-4 rounded-lg bg-primary-50 text-primary-700 text-sm">
            <i className="ri-check-line text-lg"></i>
            {message}
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto">
            <div className="honeypot-field">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="輸入您的 Email"
              required
              className="w-full sm:flex-1 px-4 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 disabled:opacity-50 whitespace-nowrap cursor-pointer"
            >
              {status === 'loading' ? '處理中...' : '立即訂閱'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-xs text-red-500">{message}</p>
        )}
      </div>
    </section>
  );
}